






























import { Component, Prop, Vue } from "vue-property-decorator"

@Component
export default class BookingReportAlert extends Vue {
  @Prop() score!: number
  @Prop() title!: string
  @Prop() warningLevel!: string
  @Prop({ default: 'primary' }) color!: string
}
